import type { BigRegisterResult } from '@bvdzorg/big-register-api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type ZorgbaseResult from '@/lib/models/zorgbase/ZorgbaseResult';

interface ZorgbaseResultWithPostcodeLocation {
	results: ZorgbaseResult[];
	location: {
		postcode: string;
		lat: number;
		lon: number;
	};
}

export interface ApiResponseError {
	status: number;
	data: {
		message: string;
	};
}

export const api = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: '/api',
	}),
	tagTypes: ['BIGNumber', 'AGBCode', 'Postcode'],
	endpoints: (builder) => ({
		findByLocation: builder.query<ZorgbaseResultWithPostcodeLocation, string>({
			query: (location) => `/filter/${location}`,
			providesTags: ['Postcode'],
		}),
		findByAGBCode: builder.query<ZorgbaseResult, string>({
			query: (agbCode) => `/agbcode/${agbCode}`,
			providesTags: ['AGBCode'],
		}),
		findByBIGNumber: builder.query<BigRegisterResult, string>({
			query: (BIGNumber) => `/big/${BIGNumber}`,
			providesTags: ['BIGNumber'],
		}),
	}),
});

// export hooks for usage in functional components
export const {
	useFindByLocationQuery,
	useLazyFindByLocationQuery,

	useFindByAGBCodeQuery,
	useLazyFindByAGBCodeQuery,

	useFindByBIGNumberQuery,
	useLazyFindByBIGNumberQuery,

	util: { getRunningQueriesThunk },
} = api;

// export endpoints for use in SSR
export const { findByLocation, findByAGBCode, findByBIGNumber } = api.endpoints;
